import { configureStore } from '@reduxjs/toolkit'
import { glApi } from './glApi'
import { miscReducer } from './miscSlice'

// The store both group-leader apps build: boot data and the TMS API slice, plus each app's own reducers.
export const createGlStore = (reducers = {}, preloadedState) =>
  configureStore({
    reducer: { misc: miscReducer, [glApi.reducerPath]: glApi.reducer, ...reducers },
    middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(glApi.middleware),
    preloadedState,
  })
